<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">

                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/DivisionMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Eligiblity Data
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        Eligiblity Data
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3" [formGroup]="teacherEligibility">
                                            <mat-form-field appearance="outline" class="example-full-width" formControlName="SearchString">
                                                <mat-label>{{'header.division-data.table.Search' | translate}}
                                                </mat-label> <input class="color" matInput placeholder="Search">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-1 prpl">
                                            <button id="New" type="button" (click)="addnewrecord()"
                                                class="btn btn-primary btn-icon-text  mt-1">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                    {{'header.division-data.table.AddNewRecord' | translate}}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        Faculty
                                                    </th>
                                                    <th class="f600">
                                                        Course
                                                    </th>
                                                    <th class="f600" width="20%">
                                                        Designation
                                                    </th>
                                                    <th class="f600">
                                                        Experience
                                                    </th>
                                                    <th class="f600 text-center" width="10%">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let eligibility of eligibilityList;">
                                                    <td>{{eligibility.Faculty}}</td>
                                                    <td>{{eligibility.CourseName}}</td>
                                                    <td>{{eligibility.Designation}}</td>
                                                    <td>{{eligibility.Experience}}</td>
                                                    <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                            (click)="editData(eligibility)">
                                                            <i class="fa fa-edit "></i> </a> <a class=" ml-2 floating"
                                                            title="Delete" (click)="deleteData(eligibility)"> <i
                                                                class="fas fa-trash"></i> </a> </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>